import {FC, useContext} from "react";
import {Box, BoxProps, Typography} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {IconContext} from "@buildwitt/shapeshift-identity";
import {CSS} from "@dnd-kit/utilities";
import {LocalList} from "@buildwitt/shapeshift-common/v2/quiz/draggableList";
import {Delete} from "@mui/icons-material";
import {useSortable as useSortableImport} from "@dnd-kit/sortable";

const useStyles = makeStyles()((theme) => ({
	adminPlaylistContentPreviewItem: {
		color: theme.palette.primary.main,
		padding: theme.spacing(1),
		borderBottom: `1px solid ${theme.palette.grey[200]}`,
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(2),
		display: "flex",
		flexGrow: "2",
		justifyContent: "space-between",
		alignItems: "center",
		"& svg": {
			color: theme.palette.common.white
		}
	},
	childrenClasses: {
		flexGrow: 5,
		padding: theme.spacing(1.5)
	},
	draggableSvg: {
		display: "inline-flex",
		alignItems: "center"
	},
	draggableIcon: {
		display: "inline-flex",
		alignItems: "center",
		marginRight: theme.spacing(1)
	},
	deleteBtn: {
		cursor: "pointer"
	}
}))

interface ICustomProps {
	item: LocalList,
	isDragDisabled?: boolean,
	minHeight?: number,
	onDelete: () => void,
	useSortable: typeof useSortableImport
}

export type IProps = BoxProps & ICustomProps;

export const AdminPlaylistContentPreviewItem: FC<IProps> = ({item, isDragDisabled, minHeight, onDelete, useSortable}) => {
	const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id: item.id});
	const {icon, cancelIcon, checkCircleIcon} = useContext(IconContext);

	const itemStyle = {
		transform: CSS.Translate.toString(transform),
		transition,
		minHeight: (minHeight ?? 0) + "px"
	};

	const {classes, cx} = useStyles();

	return (
		<Box
			key={item.id}
			className={classes.adminPlaylistContentPreviewItem}
			{...attributes}
			ref={setNodeRef}
			style={itemStyle}
		>
			{/* Use DragIndicatorIcon as the drag handle */}
			{!isDragDisabled && icon("dragIndicatorIcon", {
				style: {cursor: "grab", touchAction: "none"},
				...listeners
			})}
			<Box className={classes.childrenClasses}>

				<Typography>{item.value}</Typography>

			</Box>
			<Box className={classes.draggableIcon}>
				<Box className={classes.draggableSvg}>{item.correct === false && cancelIcon}</Box>
				<Box className={classes.draggableSvg}>{item.correct === true && checkCircleIcon}</Box>
				<Delete className={classes.deleteBtn} onClick={() => onDelete()}/>
			</Box>
		</Box>
	)
};
